var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _setup.tid } })],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("table", { staticClass: "table table-striped" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          _vm._l(_setup.shares, function (s, i) {
            return _c("tr", { key: s.Id }, [
              _c("th", { attrs: { scope: "row" } }, [_vm._v(_vm._s(i + 1))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(s.Workspace))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(s.Portfolio))]),
              _vm._v(" "),
              _c("td", [
                _c("a", { attrs: { href: "" } }, [_vm._v(_vm._s(s.Data))]),
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(s.SharedBy))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(s.SharedWith))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(s.SharedAt))]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(s.SharedFor))]),
            ])
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v("Active shares")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("#")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Workspace")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Portfolio")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Data")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Shared by")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Shared with")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Shared at")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Shared for")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }